import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import IconButton from '../../Buttons/IconButton/IconButton';
const UxContainer = styled.div `
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    overflow-x: hidden;
`;
const ScrollContainer = styled.div `
    position: relative;
    left: ${props => props.leftValue + 'px'};
    transition: left 500ms;
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: ${props => props.height};
    box-sizing: border-box;
    margin-top: ${props => props.theme.paddingsMargins.themeMenuMarginSingle};
    margin-bottom: ${props => props.theme.paddingsMargins.themeMenuMarginSingle};
`;
const HorizontalScroll = ({ stopMultiplier = 2, id, height = 'auto', shiftSize = 100, color = 'main', children, allwaysDisplayArrows = true }) => {
    const [leftValue, setLeftValue] = useState(0);
    const [scrolled, setScrolled] = useState(false);
    const [hoverContainer, setHoverContainer] = useState(allwaysDisplayArrows);
    const theme = useTheme();
    useEffect(() => {
        setHoverContainer(allwaysDisplayArrows);
    }, [allwaysDisplayArrows]);
    useEffect(() => {
        const scroller = document.getElementById(id);
        const calculateScroll = (leftValue * -1) + (stopMultiplier) >= scroller.offsetWidth;
        if (calculateScroll) {
            setScrolled(true);
        }
        else {
            setScrolled(false);
        }
    }, [leftValue]);
    return (_jsxs(UxContainer, Object.assign({ onMouseEnter: () => allwaysDisplayArrows ? null : setHoverContainer(true), onMouseLeave: () => allwaysDisplayArrows ? null : setHoverContainer(false) }, { children: [(hoverContainer && leftValue < 0) && _jsx(IconButton, { icon: 'arrowLeft', hoverEffect: false, color: 'white', style: { backgroundColor: theme.utils.getColor(color), position: 'absolute', zIndex: 2, left: '20px' }, onClick: () => setLeftValue(prev => prev + shiftSize) }), _jsx(ScrollContainer, Object.assign({ height: height, leftValue: leftValue, id: id }, { children: children })), (hoverContainer && !scrolled) && _jsx(IconButton, { icon: 'arrowRight', hoverEffect: false, color: 'white', style: { backgroundColor: theme.utils.getColor(color), position: 'absolute', zIndex: 2, right: '20px' }, onClick: () => setLeftValue(prev => prev + shiftSize * -1) })] })));
};
export default HorizontalScroll;
